export default "HOTEL_LOCATION_MODULE";
